export enum ReclassifyBatchStatus {
	Open = 1,
	Posted = 2,
	Denied = 3,
	Approved = 4,
}
